import { FaEdit } from "react-icons/fa";
import { Button } from '@art-of-hospitality-solutions-llc/ui-kit/components/button';

const FlowBuilderTriggerSidebar = ({ selectedStageIndex, currentFlowStages, handleOpenModal, setSelectedTrigger, updateDisabled, canWrite }) => {
  const selectedStage = selectedStageIndex !== null ? currentFlowStages[selectedStageIndex] : null;

  // A trigger on a saved stage attaches directly to it, so the flow-wide
  // validation state is irrelevant. Only an unsaved stage needs the whole flow
  // to be valid, because the trigger modal saves the flow to create the stage
  // before attaching the trigger to it.
  const addTriggerDisabled = (updateDisabled && !selectedStage?.createdAt) || !canWrite;

  return (
    <div className="flex flex-col justify-between h-full bg-white rounded-r p-6 z-50">
      {selectedStageIndex !== null ? (
        <div className='flex flex-col gap-4'>

          <div className='flex w-full justify-between'>
            <h2 className="text-xl font-semibold mb-4">Triggers</h2>

            {selectedStageIndex !== null &&
              <div>
                <Button
                  variant='outline'
                  type='button'
                  onClick={() => {
                    setSelectedTrigger(null)
                    handleOpenModal('trigger')
                  }}
                  disabled={addTriggerDisabled}
                >
                  Add Trigger
                </Button>
              </div>
            }
          </div>

          <div className={`${currentFlowStages[selectedStageIndex]?.flowStageTriggers?.length ? 'border' : ''} rounded-md p-1`}>
            {currentFlowStages[selectedStageIndex]?.flowStageTriggers?.map((trigger, i) => {
              return (
                <div
                  key={`trigger${i}`}
                  className={`flex items-center justify-between gap-4 px-3 py-2 text-sm ${i !== 0 ? 'border-t' : ''}`}
                >
                  <div className='flex gap-2'>
                    <p>{i + 1}. </p>
                    <p>{trigger.title}</p>
                  </div>
                  <Button
                    variant='outline'
                    className='h-fit w-7 p-1 border rounded hover:bg-gray-100'
                    onClick={() => {
                      setSelectedTrigger(trigger)
                      handleOpenModal('trigger')
                    }}
                  >
                    <FaEdit size={14} className='min-w-[15px]' />
                  </Button>
                </div>
              )
            })}
          </div>
        </div>
      ) : (
        <div>
          <h2 className="text-xl font-semibold mb-4">Triggers</h2>
          <p className="text-sm text-gray-500 mb-2">Select a Stage</p>
        </div>
      )}

    </div>
  );
};

export default FlowBuilderTriggerSidebar;